"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenAmount = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
class TokenAmount {
    constructor(wei, decimals = 0, isWei = true) {
        this.decimals = decimals;
        this._decimals = new bignumber_js_1.default(10).exponentiatedBy(decimals);
        if (isWei) {
            this.wei = new bignumber_js_1.default(wei);
        }
        else {
            this.wei = new bignumber_js_1.default(wei).multipliedBy(this._decimals);
        }
    }
    toEther() {
        return this.wei.dividedBy(this._decimals);
    }
    toWei() {
        return this.wei;
    }
    format() {
        const vaule = this.wei.dividedBy(this._decimals);
        return vaule.toFormat(vaule.isInteger() ? 0 : this.decimals);
    }
    fixed() {
        return this.wei.dividedBy(this._decimals).toFixed(4);
    }
    isNullOrZero() {
        return this.wei.isNaN() || this.wei.isZero();
    }
}
exports.TokenAmount = TokenAmount;
//# sourceMappingURL=types.js.map